import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-579ca1fe"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shuaxin1"
}, null, -1));
const _hoisted_2 = [_hoisted_1];
const _hoisted_3 = ["width", "height"];
const _hoisted_4 = ["width", "height"];
const _hoisted_5 = ["width", "height"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slider-button-icon"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "icon-arrow-right iconfont"
})], -1));
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  class: "slider-hint"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", {
    class: "slide-verify",
    style: _normalizeStyle({
      width: $props.canvasWidth + 'px'
    }),
    onselectstart: "return false;"
  }, [$data.isLoading ? _withDirectives((_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass({
      'img-loading': $data.isLoading
    }),
    style: _normalizeStyle({
      height: $props.canvasHeight + 'px'
    }),
    "element-loading-text": "Loading...",
    "element-loading-background": "rgba(0, 0, 0, 0.0)"
  }, null, 6)), [[_directive_loading, $data.isLoading]]) : _createCommentVNode("", true), $data.verifySuccess ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "success-hint",
    style: _normalizeStyle({
      height: $props.canvasHeight + 'px'
    })
  }, _toDisplayString($data.successHint), 5)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "refresh-icon",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.refresh && $options.refresh(...args))
  }, _hoisted_2), $data.isFrontCheck ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createElementVNode("canvas", {
    ref: "canvas",
    class: "slide-canvas",
    width: $props.canvasWidth,
    height: $props.canvasHeight
  }, null, 8, _hoisted_3), _createElementVNode("canvas", {
    ref: "block",
    class: "slide-block",
    width: $props.canvasWidth,
    height: $props.canvasHeight
  }, null, 8, _hoisted_4)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [_createElementVNode("img", {
    ref: "canvas",
    class: "slide-canvas",
    width: $props.canvasWidth,
    height: $props.canvasHeight
  }, null, 8, _hoisted_5), _createElementVNode("img", {
    ref: "block",
    class: _normalizeClass(['slide-block', {
      'verify-fail': $data.verifyFail
    }])
  }, null, 2)], 64)), _createElementVNode("div", {
    class: _normalizeClass(["slider", {
      'verify-active': $data.verifyActive,
      'verify-success': $data.verifySuccess,
      'verify-fail': $data.verifyFail
    }])
  }, [_createElementVNode("div", {
    class: "slider-box",
    style: _normalizeStyle({
      width: $data.sliderBoxWidth
    })
  }, [_createElementVNode("div", {
    class: "slider-button",
    id: "slider-button",
    style: _normalizeStyle({
      left: $data.sliderButtonLeft
    })
  }, _hoisted_7, 4)], 4), _createElementVNode("span", _hoisted_8, _toDisplayString($props.sliderHint), 1)], 2)], 4);
}